// extracted by mini-css-extract-plugin
export default {"procedureLayout":"ProcedureLayout_procedureLayout__NxY9Z"};